<template>
  <section class="content">
    <h1>Unsplash by Color</h1>
    <ColorViz msg="Photos uploaded in May 2019 organized by colors" />
  </section>
</template>

<script>
// @ is an alias to /src
import ColorViz from "@/components/colorviz.vue"

export default {
    name: "ColorPage",
    components: {
        ColorViz
    }
}
</script>

<style lang="stylus">
.content {
  
}
</style>


